module.exports = __webpack_public_path__ + "img/1.adb47dc4.png";